export default __webpack_public_path__ + "static/showsofindia-d41c64d02aa780695e051ad3bef402f0.png";